import  { useState, createContext} from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/home';
import Nav from './components/Nav';
import Wallet from './components/Wallet';
import MatchDetail from './components/MatchDetail';
import Bet from './components/Bet';
import Store from './components/Store';
import AdminPage from './components/AdminPage';
import Loader from './components/Loader';
import BetHistory from './components/BetHistory';


export const Addr = createContext({})

function App() {
  const [addr,setaddr]= useState("A")
  return (
    <div className="App">
    <Addr.Provider value={{"addr":addr,"setaddr":setaddr}}>
    <Router>
      <Nav/>
        <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/wallet" element={<Wallet/>} />
        <Route path="/match/:id" element={<MatchDetail/>} />
        <Route path="/bet/:id" element={<Bet/>} />
        <Route path="/detail/:id" element={<MatchDetail/>} />
        <Route path="/store" element={<Store/>} />
        <Route path="/admin" element={<AdminPage/>} />
        <Route path="/loader" element={<Loader/>} />
        <Route path="/betHistory" element={<BetHistory/>} />

      </Routes>
    </Router>
    </Addr.Provider>
   
    </div>
  );
}

export default App;
